<hfc-standalone-form-container [showButtons]="false" [showTimeLine]="false">
  <hfc-spinner *ngIf="isLoading"></hfc-spinner>

  <form *ngIf="!isLoading" [formGroup]="form" class="form" (ngSubmit)="onSubmit()">
    <div class="title">Enter a new password</div>
    <p class="text">Enter a new password for {{ invitation?.email }}</p>

    <input type="text" name="username" autocomplete="username" [value]="invitation?.email" aria-hidden="true"
      style="position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; border: 0; overflow: hidden; clip: rect(0 0 0 0); clip-path: inset(50%); white-space: nowrap;" />

    <label class="label">Password</label>
    <hfc-text-input
      type="password"
      placeholder="Password"
      autocomplete="new-password"
      class="input"
      formControlName="password"
    ></hfc-text-input>
    <label class="label">Confirm Password</label>
    <hfc-text-input
      type="password"
      placeholder="Confirm password"
      autocomplete="new-password"
      class="input"
      formControlName="confirmPassword"
    ></hfc-text-input>
    <div *ngIf="form.errors?.nomatch && form.get('confirmPassword').value" class="text-red validation-error">
      Passwords don't match
    </div>

    <hfc-password-requirements [control]="form.get('password')"></hfc-password-requirements>

    <hfc-button [isLoading]="isSubmitting" type="primary" [submit]="true" [disabled]="!form.valid"
      >Save
    </hfc-button>
    <div class="copyright">© {{ today | date: 'yy' }} {{ tenantConfigService.config.companyName }} All Rights Reserved</div>
  </form>
</hfc-standalone-form-container>
